<template>
  <div class="flex flex-col items-center p-2 space-y-6 max-w-md mx-auto w-full">
    <div class="w-full px-4">
      <div class="relative w-full py-3">
        <div
          class="h-3 2xl:h-4 w-full rounded-md overflow-hidden"
          :style="sectorLineStyle"
        ></div>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 32"
          class="absolute"
          :style="indicatorStyle"
          style="width: 24px; height: 24px; top: 80%; overflow: visible"
        >
          <path
            d="M12 32 C6.477 32 2 27.523 2 22 C2 15.045 10.205 2.935 11.363 1.418 C11.739 0.934 12.261 0.934 12.637 1.418 C13.795 2.935 22 15.045 22 22 C22 27.523 17.523 32 12 32 Z"
            fill="var(--p-surface-100)"
            stroke="var(--p-primary-900)"
            stroke-width="1"
          />
        </svg>
      </div>
    </div>
    <!-- <input
        type="range"
        min="0"
        max="100"
        v-model.number="value"
        class="w-full max-w-xs h-2 bg-slate-300 rounded-lg appearance-none cursor-pointer accent-blue-600"
      /> -->
  </div>
</template>

<script>
// A threshold that was never configured leaves the gradient without a stop,
// which invalidates the whole declaration; fall back to the given share of the
// bar so the three sectors stay visible.
function toStop(value, fallback) {
  if (value === null || value === undefined || value === "") return fallback;
  const percentage = Number(value);
  return Number.isFinite(percentage) ? percentage : fallback;
}

export default {
  name: "TailwindLinearGauge",
  props: {
    value: {
      required: true,
    },
    warning: {
      required: true,
    },
    critical: {
      required: true,
    },
    flipped: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // The two boundaries between the three sectors, in bar order. Flipping
    // swaps which threshold comes first, so both default to an even third.
    sectorStops() {
      const [first, second] = this.flipped
        ? [this.warning, this.critical]
        : [this.critical, this.warning];
      return [toStop(first, 100 / 3), toStop(second, 200 / 3)];
    },
    sectorLineStyle() {
      const redColor = "#ef4444";
      const yellowColor = "#facc15";
      const greenColor = "#22c55e";
      const [firstStop, secondStop] = this.sectorStops;
      const startColor = this.flipped ? greenColor : redColor;
      const endColor = this.flipped ? redColor : greenColor;

      return {
        background: `linear-gradient(to right,
            ${startColor} 0%,
            ${startColor} ${firstStop}%,
            ${yellowColor} ${firstStop}%,
            ${yellowColor} ${secondStop}%,
            ${endColor} ${secondStop}%,
            ${endColor} 100%
          )`,
      };
    },
    indicatorStyle() {
      return {
        left: `${this.value}%`,
        transform: "translate(-50%, -50%)",
        transition: "left 0.2s ease-out",
      };
    },
  },
};
</script>

<style scoped>
#waterDropIndicator {
  clip-path: path(
    "M12 32 C6.477 32 2 27.523 2 22 C2 15.045 10.205 2.935 11.363 1.418 C11.739 0.934 12.261 0.934 12.637 1.418 C13.795 2.935 22 15.045 22 22 C22 27.523 17.523 32 12 32 Z"
  );
}
</style>
